import { render, staticRenderFns } from "./AdminStartStopVisit.vue?vue&type=template&id=51d45f6e&scoped=true&"
import script from "./AdminStartStopVisit.vue?vue&type=script&lang=js&"
export * from "./AdminStartStopVisit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d45f6e",
  null
  
)

export default component.exports